import { NgZone } from "@angular/core";

export class BaseComponent {
    constructor(protected zone: NgZone) {
    }

    protected doAsyncUIChanges(fn: (() => void)): void {
        Promise.resolve(null).then(fn);
    }
}